/**
 * GENERATED FILE — do not edit by hand. Regenerate with:
 *   npm run generate:base-stats
 *
 * Pokémon GO base stats per national dex id: [attack, defense, stamina] for
 * the species' BASE form (shadow identical; Mega forms live in
 * megaStats.generated). FORM_BASE_STATS carries every alternate form of the
 * app's form catalogue whose stats differ from the species row, keyed by the
 * app's form id; FEMALE_BASE_STATS the gendered species whose female stats
 * differ. Consumed by the My Pokémon derivation layer (level from CP+HP,
 * PvP league ranks) through baseStatsForRecord.
 *
 * SOURCE: PvPoke (https://pvpoke.com, https://github.com/pvpoke/pvpoke),
 * MIT licensed. Copyright (c) PvPoke contributors. Permission notice travels
 * with this file per MIT terms.
 *
 * Generated: 2026-09-21T22:54:28.085Z · 1025 species · 80 forms · 3 female forms
 */
export const SPECIES_BASE_STATS: Record<number, [number, number, number]> = {
  1: [118, 111, 128],
  2: [151, 143, 155],
  3: [198, 189, 190],
  4: [116, 93, 118],
  5: [158, 126, 151],
  6: [223, 173, 186],
  7: [94, 121, 127],
  8: [126, 155, 153],
  9: [171, 207, 188],
  10: [55, 55, 128],
  11: [45, 80, 137],
  12: [167, 137, 155],
  13: [63, 50, 120],
  14: [46, 75, 128],
  15: [169, 130, 163],
  16: [85, 73, 120],
  17: [117, 105, 160],
  18: [166, 154, 195],
  19: [103, 70, 102],
  20: [161, 139, 146],
  21: [112, 60, 120],
  22: [182, 133, 163],
  23: [110, 97, 111],
  24: [167, 153, 155],
  25: [112, 96, 111],
  26: [193, 151, 155],
  27: [126, 120, 137],
  28: [182, 175, 181],
  29: [86, 89, 146],
  30: [117, 120, 172],
  31: [180, 173, 207],
  32: [105, 76, 130],
  33: [137, 111, 156],
  34: [204, 156, 191],
  35: [107, 108, 172],
  36: [178, 162, 216],
  37: [96, 109, 116],
  38: [169, 190, 177],
  39: [80, 41, 251],
  40: [156, 90, 295],
  41: [83, 73, 120],
  42: [161, 150, 181],
  43: [131, 112, 128],
  44: [153, 136, 155],
  45: [202, 167, 181],
  46: [121, 99, 111],
  47: [165, 146, 155],
  48: [100, 100, 155],
  49: [179, 143, 172],
  50: [109, 78, 67],
  51: [167, 136, 111],
  52: [92, 78, 120],
  53: [150, 136, 163],
  54: [122, 95, 137],
  55: [191, 162, 190],
  56: [148, 82, 120],
  57: [207, 138, 163],
  58: [136, 93, 146],
  59: [227, 166, 207],
  60: [101, 82, 120],
  61: [130, 123, 163],
  62: [182, 184, 207],
  63: [195, 82, 93],
  64: [232, 117, 120],
  65: [271, 167, 146],
  66: [137, 82, 172],
  67: [177, 125, 190],
  68: [234, 159, 207],
  69: [139, 61, 137],
  70: [172, 92, 163],
  71: [207, 135, 190],
  72: [97, 149, 120],
  73: [166, 209, 190],
  74: [132, 132, 120],
  75: [164, 164, 146],
  76: [211, 198, 190],
  77: [170, 127, 137],
  78: [207, 162, 163],
  79: [109, 98, 207],
  80: [177, 180, 216],
  81: [165, 121, 93],
  82: [223, 169, 137],
  83: [124, 115, 141],
  84: [158, 83, 111],
  85: [218, 140, 155],
  86: [85, 121, 163],
  87: [139, 177, 207],
  88: [135, 90, 190],
  89: [190, 172, 233],
  90: [116, 134, 102],
  91: [186, 256, 137],
  92: [186, 67, 102],
  93: [223, 107, 128],
  94: [261, 149, 155],
  95: [85, 232, 111],
  96: [89, 136, 155],
  97: [144, 193, 198],
  98: [181, 124, 102],
  99: [240, 181, 146],
  100: [109, 111, 120],
  101: [173, 173, 155],
  102: [107, 125, 155],
  103: [233, 149, 216],
  104: [90, 144, 137],
  105: [144, 186, 155],
  106: [224, 181, 137],
  107: [193, 197, 137],
  108: [108, 137, 207],
  109: [119, 141, 120],
  110: [174, 197, 163],
  111: [140, 127, 190],
  112: [222, 171, 233],
  113: [60, 128, 487],
  114: [183, 169, 163],
  115: [181, 165, 233],
  116: [129, 103, 102],
  117: [187, 156, 146],
  118: [123, 110, 128],
  119: [175, 147, 190],
  120: [137, 112, 102],
  121: [210, 184, 155],
  122: [192, 205, 120],
  123: [218, 170, 172],
  124: [223, 151, 163],
  125: [198, 158, 163],
  126: [206, 154, 163],
  127: [238, 182, 163],
  128: [198, 183, 181],
  129: [29, 85, 85],
  130: [237, 186, 216],
  131: [165, 174, 277],
  132: [91, 91, 134],
  133: [104, 114, 146],
  134: [205, 161, 277],
  135: [232, 182, 163],
  136: [246, 179, 163],
  137: [153, 136, 163],
  138: [155, 153, 111],
  139: [207, 201, 172],
  140: [148, 140, 102],
  141: [220, 186, 155],
  142: [221, 159, 190],
  143: [190, 169, 330],
  144: [192, 236, 207],
  145: [253, 185, 207],
  146: [251, 181, 207],
  147: [119, 91, 121],
  148: [163, 135, 156],
  149: [263, 198, 209],
  150: [300, 182, 214],
  151: [210, 210, 225],
  152: [92, 122, 128],
  153: [122, 155, 155],
  154: [168, 202, 190],
  155: [116, 93, 118],
  156: [158, 126, 151],
  157: [223, 173, 186],
  158: [117, 109, 137],
  159: [150, 142, 163],
  160: [205, 188, 198],
  161: [79, 73, 111],
  162: [148, 125, 198],
  163: [67, 88, 155],
  164: [145, 156, 225],
  165: [72, 118, 120],
  166: [107, 179, 146],
  167: [105, 73, 120],
  168: [161, 124, 172],
  169: [194, 178, 198],
  170: [106, 97, 181],
  171: [146, 137, 268],
  172: [77, 53, 85],
  173: [75, 79, 137],
  174: [69, 32, 207],
  175: [67, 116, 111],
  176: [139, 181, 146],
  177: [134, 89, 120],
  178: [192, 146, 163],
  179: [114, 79, 146],
  180: [145, 109, 172],
  181: [211, 169, 207],
  182: [169, 186, 181],
  183: [37, 93, 172],
  184: [112, 152, 225],
  185: [167, 176, 172],
  186: [174, 179, 207],
  187: [67, 94, 111],
  188: [91, 120, 146],
  189: [118, 183, 181],
  190: [136, 112, 146],
  191: [55, 55, 102],
  192: [185, 135, 181],
  193: [154, 94, 163],
  194: [75, 66, 146],
  195: [152, 143, 216],
  196: [261, 175, 163],
  197: [126, 240, 216],
  198: [175, 87, 155],
  199: [177, 180, 216],
  200: [167, 154, 155],
  201: [136, 91, 134],
  202: [60, 106, 382],
  203: [182, 133, 172],
  204: [108, 122, 137],
  205: [161, 205, 181],
  206: [131, 128, 225],
  207: [143, 184, 163],
  208: [148, 272, 181],
  209: [137, 85, 155],
  210: [212, 131, 207],
  211: [184, 138, 163],
  212: [236, 181, 172],
  213: [17, 396, 85],
  214: [234, 179, 190],
  215: [189, 146, 146],
  216: [142, 93, 155],
  217: [236, 144, 207],
  218: [118, 71, 120],
  219: [139, 191, 137],
  220: [90, 69, 137],
  221: [181, 138, 225],
  222: [118, 156, 146],
  223: [127, 69, 111],
  224: [197, 141, 181],
  225: [128, 90, 128],
  226: [148, 226, 163],
  227: [148, 226, 163],
  228: [152, 83, 128],
  229: [224, 144, 181],
  230: [194, 194, 181],
  231: [107, 98, 207],
  232: [214, 185, 207],
  233: [198, 180, 198],
  234: [192, 131, 177],
  235: [40, 83, 146],
  236: [64, 64, 111],
  237: [173, 207, 137],
  238: [153, 91, 128],
  239: [135, 101, 128],
  240: [151, 99, 128],
  241: [157, 193, 216],
  242: [129, 169, 496],
  243: [241, 195, 207],
  244: [235, 171, 251],
  245: [180, 235, 225],
  246: [115, 93, 137],
  247: [155, 133, 172],
  248: [251, 207, 225],
  249: [193, 310, 235],
  250: [239, 244, 214],
  251: [210, 210, 225],
  252: [124, 94, 120],
  253: [172, 120, 137],
  254: [223, 169, 172],
  255: [130, 87, 128],
  256: [163, 115, 155],
  257: [240, 141, 190],
  258: [126, 93, 137],
  259: [156, 133, 172],
  260: [208, 175, 225],
  261: [96, 61, 111],
  262: [171, 132, 172],
  263: [58, 80, 116],
  264: [142, 128, 186],
  265: [75, 59, 128],
  266: [60, 77, 137],
  267: [189, 98, 155],
  268: [60, 77, 137],
  269: [98, 162, 155],
  270: [71, 77, 120],
  271: [112, 119, 155],
  272: [173, 176, 190],
  273: [71, 77, 120],
  274: [134, 78, 172],
  275: [200, 121, 207],
  276: [106, 61, 120],
  277: [185, 124, 155],
  278: [106, 61, 120],
  279: [175, 174, 155],
  280: [79, 59, 99],
  281: [117, 90, 116],
  282: [237, 195, 169],
  283: [93, 87, 120],
  284: [192, 150, 172],
  285: [74, 110, 155],
  286: [241, 144, 155],
  287: [104, 92, 155],
  288: [159, 145, 190],
  289: [290, 166, 284],
  290: [80, 126, 104],
  291: [199, 112, 156],
  292: [153, 73, 1],
  293: [92, 42, 162],
  294: [134, 81, 197],
  295: [179, 137, 232],
  296: [99, 54, 176],
  297: [209, 114, 302],
  298: [36, 71, 137],
  299: [82, 215, 102],
  300: [84, 79, 137],
  301: [132, 127, 172],
  302: [141, 136, 137],
  303: [155, 141, 137],
  304: [121, 141, 137],
  305: [158, 198, 155],
  306: [198, 257, 172],
  307: [78, 107, 102],
  308: [121, 152, 155],
  309: [123, 78, 120],
  310: [215, 127, 172],
  311: [167, 129, 155],
  312: [147, 150, 155],
  313: [143, 166, 163],
  314: [143, 166, 163],
  315: [186, 131, 137],
  316: [80, 99, 172],
  317: [140, 159, 225],
  318: [171, 39, 128],
  319: [243, 83, 172],
  320: [136, 68, 277],
  321: [175, 87, 347],
  322: [119, 79, 155],
  323: [194, 136, 172],
  324: [151, 203, 172],
  325: [125, 122, 155],
  326: [171, 188, 190],
  327: [116, 116, 155],
  328: [162, 78, 128],
  329: [134, 99, 137],
  330: [205, 168, 190],
  331: [156, 74, 137],
  332: [221, 115, 172],
  333: [76, 132, 128],
  334: [141, 201, 181],
  335: [222, 124, 177],
  336: [196, 118, 177],
  337: [178, 153, 207],
  338: [178, 153, 207],
  339: [93, 82, 137],
  340: [151, 141, 242],
  341: [141, 99, 125],
  342: [224, 142, 160],
  343: [77, 124, 120],
  344: [140, 229, 155],
  345: [105, 150, 165],
  346: [152, 194, 200],
  347: [176, 100, 128],
  348: [222, 174, 181],
  349: [29, 85, 85],
  350: [192, 219, 216],
  351: [139, 139, 172],
  352: [161, 189, 155],
  353: [138, 65, 127],
  354: [218, 126, 162],
  355: [70, 162, 85],
  356: [124, 234, 120],
  357: [136, 163, 223],
  358: [175, 170, 181],
  359: [246, 120, 163],
  360: [41, 86, 216],
  361: [95, 95, 137],
  362: [162, 162, 190],
  363: [95, 90, 172],
  364: [137, 132, 207],
  365: [182, 176, 242],
  366: [133, 135, 111],
  367: [197, 179, 146],
  368: [211, 179, 146],
  369: [162, 203, 225],
  370: [81, 128, 125],
  371: [134, 93, 128],
  372: [172, 155, 163],
  373: [277, 168, 216],
  374: [96, 132, 120],
  375: [138, 176, 155],
  376: [257, 228, 190],
  377: [179, 309, 190],
  378: [179, 309, 190],
  379: [143, 285, 190],
  380: [228, 246, 190],
  381: [268, 212, 190],
  382: [270, 228, 205],
  383: [270, 228, 205],
  384: [284, 170, 213],
  385: [210, 210, 225],
  386: [345, 115, 137],
  387: [119, 110, 146],
  388: [157, 143, 181],
  389: [202, 188, 216],
  390: [113, 86, 127],
  391: [158, 105, 162],
  392: [222, 151, 183],
  393: [112, 102, 142],
  394: [150, 139, 162],
  395: [210, 186, 197],
  396: [101, 58, 120],
  397: [142, 94, 146],
  398: [234, 140, 198],
  399: [80, 73, 153],
  400: [162, 119, 188],
  401: [45, 74, 114],
  402: [160, 100, 184],
  403: [117, 64, 128],
  404: [159, 95, 155],
  405: [232, 156, 190],
  406: [91, 109, 120],
  407: [243, 185, 155],
  408: [218, 71, 167],
  409: [295, 109, 219],
  410: [76, 195, 102],
  411: [94, 286, 155],
  412: [53, 83, 120],
  413: [141, 180, 155],
  414: [185, 98, 172],
  415: [59, 83, 102],
  416: [149, 190, 172],
  417: [94, 172, 155],
  418: [132, 67, 146],
  419: [221, 114, 198],
  420: [108, 92, 128],
  421: [170, 153, 172],
  422: [103, 105, 183],
  423: [169, 143, 244],
  424: [205, 143, 181],
  425: [117, 80, 207],
  426: [180, 102, 312],
  427: [130, 105, 146],
  428: [156, 194, 163],
  429: [211, 187, 155],
  430: [243, 103, 225],
  431: [109, 82, 135],
  432: [172, 133, 174],
  433: [114, 94, 128],
  434: [121, 90, 160],
  435: [184, 132, 230],
  436: [43, 154, 149],
  437: [161, 213, 167],
  438: [124, 133, 137],
  439: [125, 142, 85],
  440: [25, 77, 225],
  441: [183, 91, 183],
  442: [169, 199, 137],
  443: [124, 84, 151],
  444: [172, 125, 169],
  445: [261, 193, 239],
  446: [137, 117, 286],
  447: [127, 78, 120],
  448: [236, 144, 172],
  449: [124, 118, 169],
  450: [201, 191, 239],
  451: [93, 151, 120],
  452: [180, 202, 172],
  453: [116, 76, 134],
  454: [211, 133, 195],
  455: [187, 136, 179],
  456: [96, 116, 135],
  457: [142, 170, 170],
  458: [105, 179, 128],
  459: [115, 105, 155],
  460: [178, 158, 207],
  461: [243, 171, 172],
  462: [238, 205, 172],
  463: [161, 181, 242],
  464: [241, 190, 251],
  465: [207, 184, 225],
  466: [249, 163, 181],
  467: [247, 172, 181],
  468: [225, 217, 198],
  469: [231, 156, 200],
  470: [216, 219, 163],
  471: [238, 205, 163],
  472: [185, 222, 181],
  473: [247, 146, 242],
  474: [264, 150, 198],
  475: [237, 195, 169],
  476: [135, 275, 155],
  477: [180, 254, 128],
  478: [171, 150, 172],
  479: [185, 159, 137],
  480: [156, 270, 181],
  481: [212, 212, 190],
  482: [270, 151, 181],
  483: [275, 211, 205],
  484: [280, 215, 189],
  485: [251, 213, 209],
  486: [287, 210, 221],
  487: [187, 225, 284],
  488: [152, 258, 260],
  489: [162, 162, 190],
  490: [210, 210, 225],
  491: [285, 198, 172],
  492: [210, 210, 225],
  493: [238, 238, 237],
  494: [210, 210, 225],
  495: [88, 107, 128],
  496: [122, 152, 155],
  497: [161, 204, 181],
  498: [115, 85, 163],
  499: [173, 106, 207],
  500: [235, 127, 242],
  501: [117, 85, 146],
  502: [159, 116, 181],
  503: [212, 157, 216],
  504: [98, 73, 128],
  505: [165, 139, 155],
  506: [107, 86, 128],
  507: [145, 126, 163],
  508: [206, 182, 198],
  509: [98, 73, 121],
  510: [187, 106, 162],
  511: [104, 94, 137],
  512: [206, 133, 181],
  513: [104, 94, 137],
  514: [206, 133, 181],
  515: [104, 94, 137],
  516: [206, 133, 181],
  517: [111, 92, 183],
  518: [183, 166, 253],
  519: [98, 80, 137],
  520: [144, 107, 158],
  521: [226, 146, 190],
  522: [118, 64, 128],
  523: [211, 136, 181],
  524: [121, 110, 146],
  525: [174, 143, 172],
  526: [226, 201, 198],
  527: [107, 85, 163],
  528: [161, 119, 167],
  529: [154, 85, 155],
  530: [255, 129, 242],
  531: [114, 163, 230],
  532: [134, 87, 181],
  533: [180, 134, 198],
  534: [243, 158, 233],
  535: [98, 78, 137],
  536: [128, 109, 181],
  537: [188, 150, 233],
  538: [172, 160, 260],
  539: [231, 153, 181],
  540: [96, 124, 128],
  541: [115, 162, 146],
  542: [205, 165, 181],
  543: [83, 99, 102],
  544: [100, 173, 120],
  545: [203, 175, 155],
  546: [71, 111, 120],
  547: [164, 176, 155],
  548: [119, 91, 128],
  549: [214, 155, 172],
  550: [189, 129, 172],
  551: [132, 69, 137],
  552: [155, 90, 155],
  553: [229, 158, 216],
  554: [153, 86, 172],
  555: [263, 114, 233],
  556: [201, 130, 181],
  557: [118, 128, 137],
  558: [188, 200, 172],
  559: [132, 132, 137],
  560: [163, 222, 163],
  561: [204, 167, 176],
  562: [95, 141, 116],
  563: [163, 237, 151],
  564: [134, 146, 144],
  565: [192, 197, 179],
  566: [213, 89, 146],
  567: [292, 139, 181],
  568: [96, 122, 137],
  569: [181, 164, 190],
  570: [153, 78, 120],
  571: [250, 127, 155],
  572: [98, 80, 146],
  573: [198, 130, 181],
  574: [98, 112, 128],
  575: [137, 153, 155],
  576: [176, 205, 172],
  577: [170, 83, 128],
  578: [208, 103, 163],
  579: [214, 148, 242],
  580: [84, 96, 158],
  581: [182, 132, 181],
  582: [118, 106, 113],
  583: [151, 138, 139],
  584: [218, 184, 174],
  585: [115, 100, 155],
  586: [198, 146, 190],
  587: [158, 127, 146],
  588: [137, 87, 137],
  589: [223, 187, 172],
  590: [97, 91, 170],
  591: [155, 139, 249],
  592: [115, 134, 146],
  593: [159, 178, 225],
  594: [138, 131, 338],
  595: [110, 98, 137],
  596: [201, 128, 172],
  597: [82, 155, 127],
  598: [158, 223, 179],
  599: [98, 121, 120],
  600: [150, 174, 155],
  601: [199, 214, 155],
  602: [105, 78, 111],
  603: [156, 130, 163],
  604: [217, 152, 198],
  605: [148, 100, 146],
  606: [221, 163, 181],
  607: [108, 98, 137],
  608: [169, 115, 155],
  609: [271, 182, 155],
  610: [154, 101, 130],
  611: [212, 123, 165],
  612: [284, 172, 183],
  613: [128, 74, 146],
  614: [233, 152, 216],
  615: [190, 218, 190],
  616: [72, 140, 137],
  617: [220, 120, 190],
  618: [144, 171, 240],
  619: [160, 98, 128],
  620: [258, 127, 163],
  621: [213, 170, 184],
  622: [127, 92, 153],
  623: [222, 154, 205],
  624: [154, 114, 128],
  625: [232, 176, 163],
  626: [195, 182, 216],
  627: [150, 97, 172],
  628: [232, 152, 225],
  629: [105, 139, 172],
  630: [129, 205, 242],
  631: [204, 129, 198],
  632: [217, 188, 151],
  633: [116, 93, 141],
  634: [159, 135, 176],
  635: [256, 188, 211],
  636: [156, 107, 146],
  637: [264, 189, 198],
  638: [192, 229, 209],
  639: [260, 192, 209],
  640: [192, 229, 209],
  641: [266, 164, 188],
  642: [266, 164, 188],
  643: [275, 211, 205],
  644: [275, 211, 205],
  645: [261, 182, 205],
  646: [246, 170, 245],
  647: [260, 192, 209],
  648: [250, 225, 225],
  649: [252, 199, 174],
  650: [110, 106, 148],
  651: [146, 156, 156],
  652: [201, 204, 204],
  653: [116, 102, 120],
  654: [171, 130, 153],
  655: [230, 189, 181],
  656: [122, 84, 121],
  657: [168, 114, 144],
  658: [223, 152, 176],
  659: [68, 72, 116],
  660: [112, 155, 198],
  661: [95, 80, 128],
  662: [145, 110, 158],
  663: [176, 155, 186],
  664: [63, 63, 116],
  665: [48, 89, 128],
  666: [176, 103, 190],
  667: [139, 112, 158],
  668: [221, 149, 200],
  669: [108, 120, 127],
  670: [136, 151, 144],
  671: [212, 244, 186],
  672: [123, 102, 165],
  673: [196, 146, 265],
  674: [145, 107, 167],
  675: [226, 146, 216],
  676: [164, 167, 181],
  677: [120, 114, 158],
  678: [166, 167, 179],
  679: [135, 139, 128],
  680: [188, 206, 153],
  681: [97, 272, 155],
  682: [110, 113, 186],
  683: [173, 150, 226],
  684: [109, 119, 158],
  685: [168, 163, 193],
  686: [98, 95, 142],
  687: [177, 165, 200],
  688: [96, 120, 123],
  689: [194, 205, 176],
  690: [109, 109, 137],
  691: [177, 207, 163],
  692: [108, 117, 137],
  693: [221, 171, 174],
  694: [115, 78, 127],
  695: [219, 168, 158],
  696: [158, 123, 151],
  697: [227, 191, 193],
  698: [124, 109, 184],
  699: [186, 163, 265],
  700: [203, 205, 216],
  701: [195, 153, 186],
  702: [164, 134, 167],
  703: [95, 285, 137],
  704: [101, 112, 128],
  705: [159, 176, 169],
  706: [220, 242, 207],
  707: [160, 179, 149],
  708: [125, 103, 125],
  709: [201, 154, 198],
  710: [121, 123, 135],
  711: [175, 213, 163],
  712: [117, 120, 146],
  713: [196, 240, 216],
  714: [83, 73, 120],
  715: [205, 175, 198],
  716: [250, 185, 246],
  717: [250, 185, 246],
  718: [203, 232, 239],
  719: [190, 285, 137],
  720: [261, 187, 173],
  721: [252, 216, 190],
  722: [102, 99, 169],
  723: [142, 139, 186],
  724: [210, 179, 186],
  725: [128, 79, 128],
  726: [174, 103, 163],
  727: [214, 175, 216],
  728: [120, 103, 137],
  729: [168, 145, 155],
  730: [232, 195, 190],
  731: [136, 59, 111],
  732: [159, 100, 146],
  733: [222, 146, 190],
  734: [122, 56, 134],
  735: [194, 113, 204],
  736: [115, 85, 132],
  737: [145, 161, 149],
  738: [254, 158, 184],
  739: [150, 104, 132],
  740: [231, 138, 219],
  741: [196, 145, 181],
  742: [110, 81, 120],
  743: [198, 146, 155],
  744: [117, 78, 128],
  745: [231, 140, 181],
  746: [46, 43, 128],
  747: [98, 110, 137],
  748: [114, 273, 137],
  749: [175, 121, 172],
  750: [214, 174, 225],
  751: [72, 117, 116],
  752: [126, 219, 169],
  753: [100, 64, 120],
  754: [192, 169, 172],
  755: [108, 119, 120],
  756: [154, 168, 155],
  757: [136, 80, 134],
  758: [228, 130, 169],
  759: [136, 95, 172],
  760: [226, 141, 260],
  761: [55, 69, 123],
  762: [78, 94, 141],
  763: [222, 195, 176],
  764: [165, 215, 139],
  765: [168, 192, 207],
  766: [222, 160, 225],
  767: [67, 74, 93],
  768: [218, 226, 181],
  769: [120, 118, 146],
  770: [178, 178, 198],
  771: [97, 224, 146],
  772: [184, 184, 216],
  773: [198, 198, 216],
  774: [116, 194, 155],
  775: [216, 165, 163],
  776: [165, 215, 155],
  777: [190, 145, 163],
  778: [177, 199, 146],
  779: [208, 145, 169],
  780: [231, 164, 186],
  781: [233, 179, 172],
  782: [102, 108, 128],
  783: [145, 162, 146],
  784: [222, 240, 181],
  785: [250, 181, 172],
  786: [259, 208, 172],
  787: [249, 215, 172],
  788: [189, 254, 172],
  789: [54, 57, 125],
  790: [54, 242, 125],
  791: [255, 191, 264],
  792: [255, 191, 264],
  793: [249, 210, 240],
  794: [236, 196, 216],
  795: [316, 85, 174],
  796: [330, 144, 195],
  797: [207, 199, 219],
  798: [323, 182, 139],
  799: [188, 99, 440],
  800: [251, 195, 219],
  801: [246, 225, 190],
  802: [265, 190, 207],
  803: [145, 133, 167],
  804: [263, 159, 177],
  805: [213, 298, 156],
  806: [315, 148, 142],
  807: [252, 177, 204],
  808: [118, 99, 130],
  809: [226, 190, 264],
  810: [122, 91, 137],
  811: [165, 134, 172],
  812: [239, 168, 225],
  813: [132, 79, 137],
  814: [170, 125, 163],
  815: [238, 163, 190],
  816: [132, 79, 137],
  817: [186, 113, 163],
  818: [262, 142, 172],
  819: [95, 86, 172],
  820: [160, 156, 260],
  821: [88, 67, 116],
  822: [129, 110, 169],
  823: [163, 192, 221],
  824: [46, 67, 93],
  825: [87, 157, 137],
  826: [156, 240, 155],
  827: [85, 82, 120],
  828: [172, 164, 172],
  829: [70, 104, 120],
  830: [148, 211, 155],
  831: [76, 97, 123],
  832: [159, 198, 176],
  833: [114, 85, 137],
  834: [213, 164, 207],
  835: [80, 90, 153],
  836: [197, 131, 170],
  837: [73, 91, 102],
  838: [114, 157, 190],
  839: [146, 198, 242],
  840: [71, 116, 120],
  841: [214, 144, 172],
  842: [178, 146, 242],
  843: [103, 123, 141],
  844: [202, 207, 176],
  845: [173, 163, 172],
  846: [118, 72, 121],
  847: [258, 127, 156],
  848: [97, 65, 120],
  849: [224, 140, 181],
  850: [118, 90, 137],
  851: [220, 158, 225],
  852: [121, 103, 137],
  853: [209, 162, 190],
  854: [134, 96, 120],
  855: [248, 189, 155],
  856: [98, 93, 123],
  857: [153, 133, 149],
  858: [237, 182, 149],
  859: [103, 69, 128],
  860: [145, 102, 163],
  861: [227, 139, 216],
  862: [180, 194, 212],
  863: [195, 162, 172],
  864: [253, 182, 155],
  865: [248, 176, 158],
  866: [212, 179, 190],
  867: [163, 237, 151],
  868: [90, 97, 128],
  869: [203, 203, 163],
  870: [193, 170, 163],
  871: [176, 161, 134],
  872: [76, 59, 102],
  873: [230, 155, 172],
  874: [222, 182, 225],
  875: [148, 195, 181],
  876: [208, 166, 155],
  877: [192, 121, 151],
  878: [140, 91, 176],
  879: [226, 126, 263],
  880: [195, 165, 207],
  881: [190, 166, 207],
  882: [175, 185, 207],
  883: [171, 185, 207],
  884: [239, 185, 172],
  885: [117, 61, 99],
  886: [163, 105, 169],
  887: [266, 170, 204],
  888: [254, 236, 192],
  889: [254, 236, 192],
  890: [278, 192, 268],
  891: [170, 112, 155],
  892: [254, 177, 225],
  893: [242, 215, 233],
  894: [250, 125, 190],
  895: [202, 101, 400],
  896: [246, 223, 225],
  897: [273, 146, 205],
  898: [162, 162, 225],
  899: [206, 145, 230],
  900: [253, 174, 172],
  901: [243, 181, 277],
  902: [217, 144, 260],
  903: [259, 158, 190],
  904: [222, 171, 198],
  905: [281, 162, 179],
  906: [116, 99, 120],
  907: [157, 128, 156],
  908: [233, 153, 183],
  909: [112, 96, 167],
  910: [162, 134, 191],
  911: [207, 178, 232],
  912: [120, 86, 146],
  913: [162, 123, 172],
  914: [236, 159, 198],
  915: [81, 79, 144],
  916: [186, 153, 242],
  917: [70, 77, 111],
  918: [139, 166, 155],
  919: [81, 65, 107],
  920: [199, 144, 174],
  921: [95, 45, 128],
  922: [147, 82, 155],
  923: [232, 141, 172],
  924: [98, 90, 137],
  925: [159, 157, 179],
  926: [102, 126, 114],
  927: [159, 212, 149],
  928: [100, 89, 121],
  929: [137, 131, 141],
  930: [219, 189, 186],
  931: [185, 105, 193],
  932: [95, 108, 146],
  933: [105, 160, 155],
  934: [171, 212, 225],
  935: [92, 74, 120],
  936: [234, 185, 198],
  937: [239, 189, 181],
  938: [104, 73, 156],
  939: [184, 165, 240],
  940: [105, 75, 120],
  941: [221, 132, 172],
  942: [140, 108, 155],
  943: [230, 168, 190],
  944: [124, 70, 120],
  945: [199, 149, 160],
  946: [121, 64, 120],
  947: [228, 144, 146],
  948: [97, 149, 120],
  949: [166, 209, 190],
  950: [184, 185, 172],
  951: [118, 76, 137],
  952: [216, 130, 163],
  953: [86, 108, 121],
  954: [201, 178, 181],
  955: [105, 60, 102],
  956: [204, 127, 216],
  957: [85, 110, 137],
  958: [109, 145, 163],
  959: [155, 196, 198],
  960: [109, 52, 67],
  961: [205, 136, 111],
  962: [198, 172, 172],
  963: [90, 80, 172],
  964: [143, 144, 225],
  965: [123, 107, 128],
  966: [229, 168, 190],
  967: [205, 142, 172],
  968: [161, 219, 172],
  969: [187, 104, 134],
  970: [246, 177, 195],
  971: [105, 106, 137],
  972: [186, 195, 176],
  973: [227, 145, 193],
  974: [119, 80, 239],
  975: [208, 123, 347],
  976: [196, 139, 207],
  977: [176, 178, 312],
  978: [226, 166, 169],
  979: [220, 178, 242],
  980: [127, 151, 277],
  981: [209, 136, 260],
  982: [188, 150, 268],
  983: [238, 203, 225],
  984: [249, 209, 251],
  985: [139, 234, 251],
  986: [232, 190, 244],
  987: [280, 235, 146],
  988: [261, 193, 198],
  989: [244, 195, 198],
  990: [227, 216, 207],
  991: [266, 211, 148],
  992: [245, 177, 319],
  993: [249, 179, 214],
  994: [281, 196, 190],
  995: [250, 200, 225],
  996: [134, 86, 163],
  997: [173, 128, 207],
  998: [254, 168, 229],
  999: [140, 76, 128],
  1000: [252, 190, 202],
  1001: [186, 242, 198],
  1002: [261, 167, 190],
  1003: [194, 203, 321],
  1004: [269, 221, 146],
  1005: [280, 196, 233],
  1006: [279, 171, 179],
  1007: [263, 223, 205],
  1008: [263, 223, 205],
  1009: [233, 171, 203],
  1010: [236, 194, 189],
  1011: [173, 184, 190],
  1012: [134, 96, 120],
  1013: [225, 191, 174],
  1014: [220, 191, 186],
  1015: [238, 157, 186],
  1016: [169, 208, 186],
  1017: [219, 178, 173],
  1018: [250, 215, 207],
  1019: [216, 186, 235],
  1020: [205, 208, 213],
  1021: [235, 165, 245],
  1022: [227, 195, 189],
  1023: [221, 200, 189],
  1024: [126, 165, 207],
  1025: [164, 248, 186],
};

/** GO base stats for a national dex id, or null when unknown. */
export function baseStatsForSpecies(
  dexId: number,
): { atk: number; def: number; sta: number } | null {
  const row = SPECIES_BASE_STATS[dexId];
  return row ? { atk: row[0], def: row[1], sta: row[2] } : null;
}

/** Alternate forms whose GO stats differ from their species row, by the
 * app's form id ("dialga-origin", "raichu-alola"). A form absent here has
 * its species' stats. */
export const FORM_BASE_STATS: Record<string, [number, number, number]> = {
  "raticate-alola": [135, 154, 181],
  "raichu-alola": [201, 154, 155],
  "sandshrew-alola": [125, 129, 137],
  "sandslash-alola": [177, 195, 181],
  "ninetales-alola": [170, 193, 177],
  "diglett-alola": [108, 81, 67],
  "dugtrio-alola": [201, 142, 111],
  "meowth-alola": [99, 78, 120],
  "meowth-galar": [115, 92, 137],
  "persian-alola": [158, 136, 163],
  "growlithe-hisui": [142, 92, 155],
  "arcanine-hisui": [232, 165, 216],
  "slowbro-galar": [182, 156, 216],
  "farfetchd-galar": [174, 114, 141],
  "electrode-hisui": [176, 176, 155],
  "exeggutor-alola": [230, 153, 216],
  "mr-mime-galar": [183, 169, 137],
  "tauros-paldea-combat-breed": [210, 193, 181],
  "tauros-paldea-blaze-breed": [210, 193, 181],
  "tauros-paldea-aqua-breed": [210, 193, 181],
  "articuno-galar": [250, 197, 207],
  "zapdos-galar": [252, 189, 207],
  "moltres-galar": [202, 231, 207],
  "mewtwo-armored": [182, 278, 214],
  "typhlosion-hisui": [238, 172, 177],
  "slowking-galar": [190, 180, 216],
  "qwilfish-hisui": [184, 151, 163],
  "corsola-galar": [116, 182, 155],
  "deoxys-attack": [414, 46, 137],
  "deoxys-defense": [144, 330, 137],
  "deoxys-speed": [230, 218, 137],
  "wormadam-trash": [127, 175, 155],
  "rotom-heat": [204, 219, 137],
  "rotom-wash": [204, 219, 137],
  "rotom-frost": [204, 219, 137],
  "rotom-fan": [204, 219, 137],
  "rotom-mow": [204, 219, 137],
  "dialga-origin": [270, 225, 205],
  "palkia-origin": [286, 223, 189],
  "giratina-origin": [225, 187, 284],
  "shaymin-sky": [261, 166, 225],
  "samurott-hisui": [218, 152, 207],
  "lilligant-hisui": [208, 159, 172],
  "zorua-hisui": [162, 79, 111],
  "zoroark-hisui": [261, 128, 146],
  "braviary-hisui": [213, 137, 242],
  "tornadus-therian": [238, 189, 188],
  "thundurus-therian": [295, 161, 188],
  "landorus-therian": [289, 179, 205],
  "kyurem-black": [310, 183, 245],
  "kyurem-white": [310, 183, 245],
  "pumpkaboo-small": [122, 124, 127],
  "pumpkaboo-large": [120, 122, 144],
  "pumpkaboo-super": [118, 120, 153],
  "gourgeist-small": [171, 219, 146],
  "gourgeist-large": [179, 206, 181],
  "gourgeist-super": [182, 200, 198],
  "avalugg-hisui": [214, 238, 216],
  "zygarde-10-power-construct": [205, 173, 144],
  "zygarde-complete": [184, 207, 389],
  "zygarde-10": [205, 173, 144],
  "hoopa-unbound": [311, 191, 173],
  "decidueye-hisui": [213, 174, 204],
  "lycanroc-midnight": [218, 152, 198],
  "lycanroc-dusk": [234, 139, 181],
  "minior-red": [218, 131, 155],
  "minior-orange": [218, 131, 155],
  "minior-yellow": [218, 131, 155],
  "minior-green": [218, 131, 155],
  "minior-blue": [218, 131, 155],
  "minior-indigo": [218, 131, 155],
  "minior-violet": [218, 131, 155],
  "necrozma-dusk": [277, 220, 200],
  "necrozma-dawn": [277, 220, 200],
  "indeedee-female": [184, 184, 172],
  "zacian-crowned": [332, 240, 192],
  "zamazenta-crowned": [250, 292, 192],
  "calyrex-ice": [268, 246, 205],
  "enamorus-therian": [250, 201, 179],
  "oinkologne-female": [169, 162, 251],
};

/** GO base stats for an app form id, or null when the form has no row of
 * its own (use the species row). */
export function baseStatsForForm(
  formId: string | null | undefined,
): { atk: number; def: number; sta: number } | null {
  if (!formId) return null;
  const row = FORM_BASE_STATS[formId];
  return row ? { atk: row[0], def: row[1], sta: row[2] } : null;
}

/** Species whose FEMALE form has its own GO stats, by dex id (the species
 * row is the male form). */
export const FEMALE_BASE_STATS: Record<number, [number, number, number]> = {
  876: [184, 184, 172],
  902: [199, 144, 260],
  916: [169, 162, 251],
};

/** GO base stats for a species' female form, or null when the genders share
 * the species row. */
export function baseStatsForFemale(
  dexId: number,
): { atk: number; def: number; sta: number } | null {
  const row = FEMALE_BASE_STATS[dexId];
  return row ? { atk: row[0], def: row[1], sta: row[2] } : null;
}

/** DIRECT evolutions per national dex id (base forms), from the Game
 * Master's family links. Absent key = final stage. */
export const SPECIES_EVOLUTIONS: Record<number, number[]> = {
  1: [2],
  2: [3],
  4: [5],
  5: [6],
  7: [8],
  8: [9],
  10: [11],
  11: [12],
  13: [14],
  14: [15],
  16: [17],
  17: [18],
  19: [20],
  21: [22],
  23: [24],
  25: [26],
  27: [28],
  29: [30],
  30: [31],
  32: [33],
  33: [34],
  35: [36],
  37: [38],
  39: [40],
  41: [42],
  42: [169],
  43: [44],
  44: [45, 182],
  46: [47],
  48: [49],
  50: [51],
  52: [53],
  54: [55],
  56: [57],
  57: [979],
  58: [59],
  60: [61],
  61: [62, 186],
  63: [64],
  64: [65],
  66: [67],
  67: [68],
  69: [70],
  70: [71],
  72: [73],
  74: [75],
  75: [76],
  77: [78],
  79: [80, 199],
  81: [82],
  82: [462],
  84: [85],
  86: [87],
  88: [89],
  90: [91],
  92: [93],
  93: [94],
  95: [208],
  96: [97],
  98: [99],
  100: [101],
  102: [103],
  104: [105],
  108: [463],
  109: [110],
  111: [112],
  112: [464],
  113: [242],
  114: [465],
  116: [117],
  117: [230],
  118: [119],
  120: [121],
  123: [212, 900],
  125: [466],
  126: [467],
  129: [130],
  133: [134, 135, 136, 196, 197, 470, 471, 700],
  137: [233],
  138: [139],
  140: [141],
  147: [148],
  148: [149],
  152: [153],
  153: [154],
  155: [156],
  156: [157],
  158: [159],
  159: [160],
  161: [162],
  163: [164],
  165: [166],
  167: [168],
  170: [171],
  172: [25],
  173: [35],
  174: [39],
  175: [176],
  176: [468],
  177: [178],
  179: [180],
  180: [181],
  183: [184],
  187: [188],
  188: [189],
  190: [424],
  191: [192],
  193: [469],
  194: [195],
  198: [430],
  200: [429],
  203: [981],
  204: [205],
  206: [982],
  207: [472],
  209: [210],
  215: [461],
  216: [217],
  217: [901],
  218: [219],
  220: [221],
  221: [473],
  223: [224],
  228: [229],
  231: [232],
  233: [474],
  234: [899],
  236: [106, 107, 237],
  238: [124],
  239: [125],
  240: [126],
  246: [247],
  247: [248],
  252: [253],
  253: [254],
  255: [256],
  256: [257],
  258: [259],
  259: [260],
  261: [262],
  263: [264],
  265: [266, 268],
  266: [267],
  268: [269],
  270: [271],
  271: [272],
  273: [274],
  274: [275],
  276: [277],
  278: [279],
  280: [281],
  281: [282, 475],
  283: [284],
  285: [286],
  287: [288],
  288: [289],
  290: [291],
  293: [294],
  294: [295],
  296: [297],
  298: [183],
  299: [476],
  300: [301],
  304: [305],
  305: [306],
  307: [308],
  309: [310],
  315: [407],
  316: [317],
  318: [319],
  320: [321],
  322: [323],
  325: [326],
  328: [329],
  329: [330],
  331: [332],
  333: [334],
  339: [340],
  341: [342],
  343: [344],
  345: [346],
  347: [348],
  349: [350],
  353: [354],
  355: [356],
  356: [477],
  360: [202],
  361: [362, 478],
  363: [364],
  364: [365],
  366: [367, 368],
  371: [372],
  372: [373],
  374: [375],
  375: [376],
  387: [388],
  388: [389],
  390: [391],
  391: [392],
  393: [394],
  394: [395],
  396: [397],
  397: [398],
  399: [400],
  401: [402],
  403: [404],
  404: [405],
  406: [315],
  408: [409],
  410: [411],
  412: [413, 414],
  415: [416],
  418: [419],
  420: [421],
  422: [423],
  425: [426],
  427: [428],
  431: [432],
  433: [358],
  434: [435],
  436: [437],
  438: [185],
  439: [122],
  440: [113],
  443: [444],
  444: [445],
  446: [143],
  447: [448],
  449: [450],
  451: [452],
  453: [454],
  456: [457],
  458: [226],
  459: [460],
  495: [496],
  496: [497],
  498: [499],
  499: [500],
  501: [502],
  502: [503],
  504: [505],
  506: [507],
  507: [508],
  509: [510],
  511: [512],
  513: [514],
  515: [516],
  517: [518],
  519: [520],
  520: [521],
  522: [523],
  524: [525],
  525: [526],
  527: [528],
  529: [530],
  532: [533],
  533: [534],
  535: [536],
  536: [537],
  540: [541],
  541: [542],
  543: [544],
  544: [545],
  546: [547],
  548: [549],
  550: [902],
  551: [552],
  552: [553],
  554: [555],
  557: [558],
  559: [560],
  562: [563],
  564: [565],
  566: [567],
  568: [569],
  570: [571],
  572: [573],
  574: [575],
  575: [576],
  577: [578],
  578: [579],
  580: [581],
  582: [583],
  583: [584],
  585: [586],
  588: [589],
  590: [591],
  592: [593],
  595: [596],
  597: [598],
  599: [600],
  600: [601],
  602: [603],
  603: [604],
  605: [606],
  607: [608],
  608: [609],
  610: [611],
  611: [612],
  613: [614],
  616: [617],
  619: [620],
  622: [623],
  624: [625],
  625: [983],
  627: [628],
  629: [630],
  633: [634],
  634: [635],
  636: [637],
  650: [651],
  651: [652],
  653: [654],
  654: [655],
  656: [657],
  657: [658],
  659: [660],
  661: [662],
  662: [663],
  664: [665],
  665: [666],
  667: [668],
  669: [670],
  670: [671],
  672: [673],
  674: [675],
  677: [678],
  679: [680],
  680: [681],
  682: [683],
  684: [685],
  686: [687],
  688: [689],
  690: [691],
  692: [693],
  694: [695],
  696: [697],
  698: [699],
  704: [705],
  705: [706],
  708: [709],
  710: [711],
  712: [713],
  714: [715],
  722: [723],
  723: [724],
  725: [726],
  726: [727],
  728: [729],
  729: [730],
  731: [732],
  732: [733],
  734: [735],
  736: [737],
  737: [738],
  739: [740],
  742: [743],
  744: [745],
  747: [748],
  749: [750],
  751: [752],
  753: [754],
  755: [756],
  757: [758],
  759: [760],
  761: [762],
  762: [763],
  767: [768],
  769: [770],
  772: [773],
  782: [783],
  783: [784],
  789: [790],
  790: [791, 792],
  803: [804],
  808: [809],
  810: [811],
  811: [812],
  813: [814],
  814: [815],
  816: [817],
  817: [818],
  819: [820],
  821: [822],
  822: [823],
  824: [825],
  825: [826],
  827: [828],
  829: [830],
  831: [832],
  833: [834],
  835: [836],
  837: [838],
  838: [839],
  840: [841, 842, 1011],
  843: [844],
  846: [847],
  848: [849],
  850: [851],
  852: [853],
  854: [855],
  856: [857],
  857: [858],
  859: [860],
  860: [861],
  868: [869],
  872: [873],
  878: [879],
  884: [1018],
  885: [886],
  886: [887],
  891: [892],
  906: [907],
  907: [908],
  909: [910],
  910: [911],
  912: [913],
  913: [914],
  915: [916],
  917: [918],
  919: [920],
  921: [922],
  922: [923],
  924: [925],
  926: [927],
  928: [929],
  929: [930],
  932: [933],
  933: [934],
  935: [936, 937],
  938: [939],
  940: [941],
  942: [943],
  944: [945],
  946: [947],
  948: [949],
  951: [952],
  953: [954],
  955: [956],
  957: [958],
  958: [959],
  960: [961],
  963: [964],
  965: [966],
  969: [970],
  971: [972],
  974: [975],
  996: [997],
  997: [998],
  999: [1000],
  1011: [1019],
  1013: [1012],
};

/** Every stage reachable by evolving this species, transitive, deduped. */
export function evolutionChainFor(dexId: number): number[] {
  const out: number[] = [];
  const queue = [...(SPECIES_EVOLUTIONS[dexId] ?? [])];
  while (queue.length > 0) {
    const next = queue.shift()!;
    if (out.includes(next)) continue;
    out.push(next);
    queue.push(...(SPECIES_EVOLUTIONS[next] ?? []));
  }
  return out;
}
